import wallpaper1 from "./wallpaper1.jpg";
import wallpaper2 from "./wallpaper2.jpg";
import wallpaper3 from "./wallpaper3.jpg";
import wallpaper4 from "./wallpaper4.jpg";
import wallpaper5 from "./wallpaper5.jpg";
import coverflow from "./coverflow.png";
import games from "./games.jpeg";
import allsongs from "./allsongs.gif";
import artists from "./artists.jpg";
import albums from "./albums.png";
import song1Img from "./stay.png";
import song2Img from "./deserve-you.jpeg";
import song3Img from "./yummy.png";

const images = {
	wallpaper1,
	wallpaper2,
	wallpaper3,
	wallpaper4,
	wallpaper5,
	coverflow,
	games,
	allsongs,
	artists,
	albums,
	song1Img,
	song2Img,
	song3Img,
};

export default images;
